import { isValid, parseISO } from 'date-fns';

import { IYearMonth, toYearMonth } from '~/utils/date/date';

const getVisitMonth = (date: Date | string | null | undefined): IYearMonth | undefined => {
  if (!date) return undefined;
  const visitDate = typeof date === 'string' ? parseISO(date) : date;
  return isValid(visitDate) ? toYearMonth(visitDate) : undefined;
};

export default getVisitMonth;
